import React, { Fragment, useEffect, useState } from "react";
import { Box, Grid, Paper, Tooltip, Typography } from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import backBoardPic from "../../Assets/frames/BackingBoard.jpg";
import Parse from "../../API/ParseServer";
const UserArtworkItem: React.FC<{
  item: any;
  pricing: any;
  updateTotal: any;
  loseDiscount: any;
}> = (props) => {
  const [inputQuantity, setInputQuantity] = useState(
    Number(props.item.quantity),
  );
  const [quantity, setQuantity] = useState(1000);
  const [quantityloading, setQuantityloading] = useState(false);
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12),
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const quantityDecHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      inputQuantity !== 1 &&
      !quantityloading &&
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, false))
    ) {
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: userArtwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: userArtwork.id,
            quantity: inputQuantity - 1,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current - 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };
  const quantityIncHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      inputQuantity < quantity &&
      !quantityloading &&
      (user || localStorage.getItem("guestId"))
    ) {
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: userArtwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: userArtwork.id,
            quantity: inputQuantity + 1,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current + 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };
  const deleteHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, true))
    ) {
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: userArtwork.id,
            quantity: 0,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: userArtwork.id,
            quantity: 0,
            frameId: "",
            specifications: {
              paper: props.item.specifications.paper,
              mountboard: {},
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "UserArtwork",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) window.location.reload();
        props.updateTotal();
      }
    }
  };
  const userArtwork = props.item.userArtwork;
  const area =
    Number(props.item.specifications.width) *
    Number(props.item.specifications.height);
  const VAT = props.pricing ? props.pricing.get("VAT") : 0.2;
  const multiplierFactor = props.pricing
    ? props.pricing.get("multiplierFactor")
    : 4;

  const paper = props.pricing ? props.pricing.get("paper_cm2") : 0.03;
  function addCommas(num: number | String) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Grid sx={{ width: "100%", borderBottom: "2px solid #f3f4f5" }} container>
      <Grid
        md={4}
        xs={12}
        item
        sx={{ py: 4, display: "flex", justifyContent: "center" }}
      >
        {userArtwork.get("resizedImage") ? (
          <img
            src={userArtwork.get("resizedImage").url()}
            alt="User Artwork"
            style={{
              maxHeight: "20rem",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              aspectRatio: 1,
              backgroundColor: "gray",
            }}
          ></Box>
        )}
      </Grid>

      <Grid
        item
        md={7.8}
        xs={12}
        sx={{
          px: 1,
          py: 4,
          mt: { xs: 2, md: 0 },
          pl: { md: 4 },
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "1000" }} component="h2">
          {props.item.title}
        </Typography>
        {/* <Typography variant="h6">Lorem ipsum dolor sit.</Typography> */}
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1" sx={{ width: "20rem" }}>
              Artwork Dimensions
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">
              {props.item.specifications.width} x{" "}
              {props.item.specifications.height}
              cm
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1" sx={{ width: "20rem" }}>
              Printing
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">
              {props.item.specifications.paper}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1" sx={{ width: "20rem" }}>
              Quantity
            </Typography>
          </Grid>
          <Grid sx={{ display: "flex", gap: 1 }} item xs={5}>
            <button
              className={
                inputQuantity === 1
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityDecHandler}
              disabled={inputQuantity === 1}
            >
              -
            </button>
            <Typography
              sx={{
                border: "2px solid #8d462b",
                borderRadius: 2,
                p: "2px 10px",
                width: "2.5rem",
                textAlign: "center",
              }}
            >
              {inputQuantity}
            </Typography>
            <button
              className={
                inputQuantity === quantity
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityIncHandler}
              disabled={inputQuantity === quantity}
            >
              +
            </button>
          </Grid>{" "}
        </Grid>

        <br />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Link to={`/online-printing/edit`}>
              <button
                className={styles["edit-button"]}
                onClick={() => {
                  localStorage.setItem("editItemId", props.item.itemId);
                  localStorage.setItem("uploadImageId", userArtwork.id);
                  localStorage.setItem("framingMode", "artwork");
                }}
              >
                <SettingsIcon sx={{ fontSize: "27px", mr: 1 }} />
                Edit
              </button>
            </Link>

            <button
              className={styles["edit-button"]}
              onClick={deleteHandler}
              // id={.id}
            >
              <DeleteIcon sx={{ fontSize: "27px", mr: 1 }} /> Delete
            </button>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            }}
          >
            <Typography component="h2" variant="h4">
              £
              {addCommas(
                (
                  (2e-16 * Math.pow(Number(area * paper), 4) +
                    1e-11 * Math.pow(Number(area * paper), 3) -
                    1e-7 * Math.pow(Number(area * paper), 2) +
                    0.0117 * Number(area * paper) +
                    3.5525) *
                  inputQuantity *
                  (1 + Number(VAT))
                )
                  // * multiplierFactor
                  .toFixed(2),
              )}
            </Typography>
            <Typography sx={{ color: "gray", mt: 1 }} variant="subtitle2">
              incl. £
              {addCommas(
                (
                  (2e-16 * Math.pow(Number(area * paper), 4) +
                    1e-11 * Math.pow(Number(area * paper), 3) -
                    1e-7 * Math.pow(Number(area * paper), 2) +
                    0.0117 * Number(area * paper) +
                    3.5525) *
                  inputQuantity *
                  // multiplierFactor *
                  Number(VAT)
                ).toFixed(2),
              )}
              VAT
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UserArtworkItem;
